// import { Alert } from 'rsuite';
import { alert } from './rsuite/Alerts';
/**
     * Alert Info message that only shows each specific time
     * @param {*} message String
     * @param {*} condition Boolean state
     * @param {*} setShowAlert setBoolean state
     * @param {*} time Integer seconds (optional)
     */
export const alertInfo = (message, condition, setShowAlert, time = 3000) => {
    if (condition) {
        // Alert.info(message, time);
        alert('info', message, time);
        // Disable Alert
        setShowAlert(false);
        // Enable Alert
        setTimeout(() => {
            setShowAlert(true);
        }, time + 1000);
    }
};

/**
     * Alert Warning message that only shows each specific time
     * @param {*} message String
     * @param {*} condition Boolean state
     * @param {*} setShowAlert setBoolean state
     * @param {*} time Integer seconds (optional)
     */
export const alertWarning = (message, condition, setShowAlert, time = 3000) => {
    if (condition) {
        // Alert.warning(message, time);
        alert('warning', message, time);
        // Disable Alert
        setShowAlert(false);
        // Enable Alert
        setTimeout(() => {
            setShowAlert(true);
        }, time + 1000);
    }
};

/**
     * Alert Error message that only shows each specific time
     * @param {*} message String
     * @param {*} condition Boolean state
     * @param {*} setShowAlert setBoolean state
     * @param {*} time Integer seconds (optional)
     */
export const alertError = (message, condition, setShowAlert, time = 3000) => {
    if (condition) {
        // Alert.warning(message, time);
        alert('error', message, time);
        // Disable Alert
        setShowAlert(false);
        // Enable Alert
        setTimeout(() => {
            setShowAlert(true);
        }, time + 1000);
    }
};

/**
 * You will need
 */
// const [showAlert, setShowAlert] = useState(true);
// How to use
// alertWarning('Por favor, ingrese una contraseña.', showAlert, setShowAlert);
